<template>
    <div class="pop" v-show="show"  @click.stop='_=>{}'>
        <div class="box">
            <div class="title">
                {{title}}
                <span @click="show = false" class="closeBtn"></span>
            </div>
            <div class="wrap">
                <div v-html='content' style='margin-bottom:10px;'></div>
                <template v-if="!noAgreement">
                    <button @click="exchange" class="arg_btn">{{argBtn}}</button>
                    <div class="argument" :class="{show: argBtn == '收起'}">
                        <div style='padding: 5px 10px;' v-html='argument'></div>
                    </div>
                </template>
                <div class="selectItem" :class="{active: index == chooseIndex}" @click="choose(item,index)"
                    v-for="(item,index) in selectList" :key="index">
                    <i></i>
                    {{item.text}}
                </div>
                <div class="tips" v-show='tip'>请选择确认身份后再点击确认</div>
                <button class="roger" @click="close">确认</button>
            </div>

        </div>
    </div>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'popselect',
        data: () => ({
            show: true,
            argBtn: '根据CME关于专业和非专业用户的规定',
            selectList: [],
            chooseIndex: -1,
            tip: false
        }),
        props: {
            list: {
                type: Array,
                default: () => ([])
            },
            title: {
                default: '确认购买人身份',
                type: String
            },
            content: {
                default: '请确认本人身份 <br>（针对专业用户和非专业用户数据授权费不同）',
                type: String
            },
            argument: {
                default: `<span>非专业用户是指包括1. 个人、自然人用户 2. 某些小型商业实体（有限责任公司、合伙、信托或法人），获得和使用市场数据（不包括任何场内交易数据），并受到下列限制的：</span><span style="margin-top:15px;display: block;">非专业订阅人必须：<br>a.拥有一个活跃的期货交易账户；<br>b.是个人，自然人或小型商业实体；</span><span style="margin-top:15px;display: block;">非专业用户必须不能是：<br>c.任何交易所的会员（亦不得拥有或租用任何交易所的任何一类会员资格）；<br>d.在任何证券交易所、商品交易所、期货交易所、合约市场或者任何监管机构、专业协会或经过任何的专业机构登记或获得资格认证的专业交易员或投资顾问；<br>e.作为一个机构的代表从事经济业务，银行业，投资业或其他金融活动；</span><span style="margin-top:15px;display: block;">非专业用户使用信息：<br>f.仅为用户本人使用；<br>g.不应超出用户本人所能管理的资产，不能和任何第三方有任何资产的联系；</span><span style="margin-top:15px;display: block;">非专业用户获取信息：<br>h.从每一经销商处获取市场资料的渠道可以有两（2）条,并且订阅人须在能将订单传送到交易所电子交易平台的设备（“订单传送设备”）上浏览市场数据。</span><span>订单传送设备：有权接收实时信息，并能够向CME Globex电子交易平台传送指令的交易终端。</span><span style="margin-top:15px;display: block;">不符合非专业用户资格条件的任何订阅人，均应被视为专业用户。</span><span style="display: block;margin-bottom:15px;">不管本档中有何规定，在各种情况下，交易所均保留对某一订阅人是非专业用户还是专业用户作出最终认定的权利，交易所保留随时修订本政策或者终止对非专业用户减低收费标准的做法的权利。</span><span style="display: block;">请选择您的类别，然后本文档将被文华财经保存，备交易所随时审查。<br>请注意，如果订阅人不再符合非专业用户的资格条件，则其必须在合理可行的范围内尽快通知文华财经。</span>`,
                type: String
            },
            argumentName: {
                default: '根据CME关于专业和非专业用户的规定',
                type: String
            },
            confirmCall: {
                default: () => {},
                type: Function
            },
            noAgreement: {
                default: false,
                type: Boolean
            }
        },
        methods: {
            close() {
                if (this.chooseIndex == -1) {
                    this.tip = true
                    return
                }
                this.show = false
                
                this.confirmCall && this.confirmCall(this.selectList[this.chooseIndex].val || this.chooseIndex)
            },
            exchange() {
                if (this.argBtn == this.argumentName) {
                    this.argBtn = '收起'
                } else {
                    this.argBtn = this.argumentName
                }

            },
            choose(item, index) {
                this.chooseIndex = index
                this.tip = false
            }
        },
        watch: {
            list: {
                handler(val) {
                    if (!val || val.length <= 0) return
                    this.selectList = val.map(v => ({
                        ...v,
                        _selected: false
                    }))
                },
                immediate: true
            },
            argumentName: {
                handler(val) {
                    this.argBtn = val
                },
                immediate: true
            }
        },
        components: {

        },
        mounted() {

        }
    }
</script>

<style scoped>
    .tips {
        color: #97253F;
        margin-top: 5px;
        margin-left: 20px;
    }
    .pop {
        position: fixed;
        z-index: 2000;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .2);
    }

    .box {
        width: 494px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .title {
        height: 34px;
        background: url(../assets/image/confirm_title_bg.jpg) no-repeat;
        color: #fafafa;
        font-size: 15px;
        line-height: 34px;
        padding-left: 11px;
        position: relative;
    }

    .wrap {
        background: #fff;
        border: 1px solid #8b8b8b;
        border-top: 0;
        padding: 30px 60px;
        color: #7c7c7c;
        font-weight: bolder;
        font-size: 14px;
    }

    .roger {
        color: #fff;
        font-weight: bolder;
        background: rgb(73, 132, 212);
        padding: 5px 28px;
        cursor: pointer;
        display: block;
        width: 96px;
        zoom: 1;
        margin: 0 auto;
        border: 0;
        margin-top: 25px;
        outline: 0;
    }

    .arg_btn {
        background: transparent;
        border: 0;
        outline: 0;
    }

    .argument {
        color: #7c7c7c;
        max-height: 200px;
        height: 0;
        overflow: hidden;
        overflow-y: auto;
        background: #e0edfd;
        margin-bottom: 10px;
        transition: height .3s;
    }

    .argument.show {
        height: 200px;
    }

    .arg_btn {
        color: #1261D2;
        text-decoration: underline;
        cursor: pointer;
        margin-bottom: 10px;
    }

    .selectItem {
        cursor: default;
    }

    .selectItem i {
        display: inline-block;
        width: 15px;
        height: 17px;
        vertical-align: middle;
        background: url(../assets/image/choose_01_y.png) no-repeat center;
    }

    .selectItem.active i {
        background: url(../assets/image/choose_01_y22.png) no-repeat center;
    }

    .closeBtn {
        width: 35px;
        height: 35px;
        position: absolute;
        right: 0;
        top: 0;
        background: url(../assets/image/close.png) no-repeat center;
        background-size: 12px;
        cursor: pointer;
    }
</style>